import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash'
import {renderTextField} from '../../../common/RenderFields'


class AddUserForm extends Component {

    render() {
        const { handleSubmit } = this.props;
        //console.log('render AddUserForm', this.props)

        return (<form onSubmit={handleSubmit}>

                <div>
                    <Field name="name" label="Name" inputClass="input-wide" component={renderTextField}/>
                </div>

                <div>
                    <Field name={`email`} label="Email" inputClass="input-wide" component={renderTextField}/>
                </div>
                <div>
                    <Field name={`phone`} label="Phone" inputClass="input-wide" component={renderTextField}/>
                </div>
                <div>
                    <Field name={`password`} label="Password" inputClass="input-wide" component={renderTextField}/>
                </div>
                <button className="submit" type="submit" >Create</button>
                <button className="link" onClick={this.props.onCancel} >Cancel</button>
            </form>
         )
    }
}

const validate = (values) => {
    const errors = {}

    _.forEach([`name`, `phone`, `email`, `password`], k => {
        if (!values[k]) {
            errors[k] = 'Required'
        }
    })

    values.password = (values.password || '').trim()
    if (values.password.length < 7) {
        errors.password = 'Password must be at least 7 characters'
    }

    //console.log('validate', values, errors)

    return errors
}

AddUserForm = reduxForm({
    form: 'AddUserForm',
    validate
})(AddUserForm);

export default AddUserForm


// WEBPACK FOOTER //
// ./src/components/admin/groups/Users/AddUserForm.jsx